import { isDOM } from '@app/shared/predicates'

import { createApp } from '@app/adapters/create-app'

import ToastManager from '../components/toast-manager.vue'

export const setupToastManager = (): void => {
  window.onDomLoad(($dom) => {
    const doc = $dom[0]

    if (!isDOM(doc)) {
      return
    }

    const element = doc.getElementById('sf-toast-container')

    if (!element) {
      return
    }

    createApp(ToastManager, {
      singletonId: 'sf-toast-manager',
    }).mount(element)
  })
}
